import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeLeave  {
    _originalTypeClassName = "zERP.BO.EmployeeLeave";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeLeave.translate = translateService;
}
this.LeaveTypes = [];
this.Id = null;
this.Year = null;
this.DateFrom = null;
this.DateTo = null;
this.TotalDays = null;
this.RequestedDays = 0;
this.ApprovedDays = 0;
this.RemaingDays = 0;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Year:any;
DateFrom:any;
DateTo:any;
TotalDays:any;
RequestedDays:any;
ApprovedDays:any;
RemaingDays:any;
LeaveTypes:any;
EmployeeContract:any;
static setLeaveTypes = ($this, items) => {
                if (items == null) items = [];
                if ($this.LeaveTypes == null) $this.LeaveTypes = [];

                const copyItems = Common.cloneObject(items);

                while ($this.LeaveTypes.length > 0) {
                    Domain.EmployeeLeave.removeLeaveTypes($this, $this.LeaveTypes[0]);
                }

                Domain.EmployeeLeave.addManyLeaveTypes($this, copyItems);
            }
static addManyLeaveTypes = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeeLeave.addLeaveTypes($this, items[i]);
                }
            }
static addLeaveTypes = ($this, item) => {
                if ($this.LeaveTypes == null) $this.LeaveTypes = [];
                if (item == null || $this.LeaveTypes.indexOf(item) > -1) return;
                $this.LeaveTypes.push(item);
}
static addRangeLeaveTypes = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeeLeave.addLeaveTypes($this, item));
            }
static removeLeaveTypes = ($this, item) => {
                if ($this == null || $this.LeaveTypes == null || $this.LeaveTypes.indexOf(item) === -1) return;
                var _index = $this.LeaveTypes.indexOf(item);
                $this.LeaveTypes.splice(_index, 1);
}
static clearLeaveTypes = ($this) => { $this.LeaveTypes = null; }
static setEmployeeContract = ($this, value) => {
var oldValue = $this.EmployeeContract;
$this.EmployeeContract = value;
if (value != null) {
if (oldValue != null) {
Domain.EmployeeContract.removeLeaveTypes(oldValue, $this);
}
Domain.EmployeeContract.addLeaveTypes(value, $this);
}
}

static GetForPeriod(contract: any,leaveType: any,from: any,to: any): any{if (contract == null || leaveType == null || Domain.DateHelper.IsDateNull(from)) {return null;}
return contract?.LeaveTypes?.linq?.where((l) => l?.LeaveTypes?.linq?.contains(leaveType) && (((new Date(new Date(new Date(l?.DateFrom)?.setHours(0, 0, 0, 0))).getTime()) <= (new Date(new Date(new Date(from)?.setHours(0, 0, 0, 0))).getTime()) && (new Date(new Date(new Date(l?.DateTo)?.setHours(0, 0, 0, 0))).getTime()) >= (new Date(new Date(new Date(from)?.setHours(0, 0, 0, 0))).getTime())) || ((new Date(new Date(new Date(l?.DateFrom)?.setHours(0, 0, 0, 0))).getTime()) <= (new Date(new Date(new Date(to)?.setHours(0, 0, 0, 0))).getTime()) && (new Date(new Date(new Date(l?.DateTo)?.setHours(0, 0, 0, 0))).getTime()) >= (new Date(new Date(new Date(to)?.setHours(0, 0, 0, 0))).getTime()))))?.firstOrDefault(null);
}
static Open(contract: any,rule: any,override: any,year: any): any{let from = (rule?.EntitllmentRefreshPeriod == Domain.LeaveBalanceCalendar.Anniversary ? moment([year, ((moment(contract?.StartDate).month() + 1)) - 1, moment(contract?.StartDate).date(), 12, 0, 0]).toDate() : moment([year, (1) - 1, 1, 12, 0, 0]).toDate());
let to = (moment((moment(from).add(-1, "d")).toDate()).add(1, "y")).toDate();
let existing = Domain.EmployeeLeave.GetForPeriod(contract, rule, from, to);
if (existing == null && rule?.InheritEntitlement == true) {existing = Domain.EmployeeLeave.GetForPeriod(contract, rule?.InheritEntitlementFrom, from, to);if (existing == null) {existing = Domain.EmployeeLeave.Open(contract, rule?.InheritEntitlementFrom, override, year);}if (existing == null) {throw Error("Failed to locate existing " + rule?.InheritEntitlementFrom?.Name);}}
let alreadyHad = existing != null;
if (existing == null) {existing = new Domain.EmployeeLeave();Domain.EmployeeLeave.setEmployeeContract(existing, contract);existing?.LeaveTypes?.add(rule);existing.Year = year;existing.DateFrom = from;existing.DateTo = to;contract?.LeaveTypes?.add(existing);}
if (!(existing?.LeaveTypes?.linq?.contains(rule))) {existing?.LeaveTypes?.add(rule);}
if (alreadyHad && !(override)) {return existing;}
existing.TotalDays = Domain.LeaveRule.CalculateRight(rule, year, contract);
Domain.EmployeeLeave.UpdateBalanace(existing);
return existing;
}
static UpdateBalanace($this: any): any{if (CLMS.Framework.Number.Equal(() => $this.RequestedDays, () => null)) {$this.RequestedDays = 0;}
if (CLMS.Framework.Number.Equal(() => $this.ApprovedDays, () => null)) {$this.ApprovedDays = 0;}
$this.RemaingDays = Joove.Common.safeNumber($this?.TotalDays) - Joove.Common.safeNumber($this?.ApprovedDays) - Joove.Common.safeNumber($this?.RequestedDays);
if (CLMS.Framework.Number.LessThan(() => $this.RemaingDays, () => 0)) {$this.RemaingDays = 0;}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}